import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { SubscriptionManagementService, Application } from './subscription-management.service';

@Injectable()
export class ResolverAppsService implements Resolve<Application[]> {

	constructor(
		private subscriptionService: SubscriptionManagementService
	) { }

	async resolve(): Promise<Application[]> {
		/* const apps = await new Promise<Application[]>((resolve) => {
			this.subscriptionService.getApps((rsp) => {
				resolve(rsp);
			}, () => {
				console.log('Faild to get apps.');
				resolve([]);
			});
		}); */
		return [];
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-apps.service.ts